(function () {
  'use strict';

  var root = document.getElementById('enamio-flavor-poll');
  if (!root) return;
  var optionsEl = document.getElementById('ep-options');
  var totalEl = document.getElementById('ep-total');
  var statusEl = document.getElementById('ep-status');
  if (!optionsEl || !totalEl || !statusEl) return;

  var RESULTS_URL = '/apps/enamio-poll/results';
  var VOTE_URL = '/apps/enamio-poll/vote';
  var VOTE_KEY = 'enamio_flavor_poll_vote';
  var VISITOR_KEY = 'enamio_poll_visitor_id';
  var current = null;
  var renderedSnapshot = '';
  var submitting = false;
  var refreshSerial = 0;
  var lastRenderedSerial = 0;
  var lastRefresh = 0;
  var subtitle = root.querySelector('.ep-sub');
  if (subtitle) subtitle.textContent = 'Please vote once. The winner goes into development.';

  function stored(key) {
    try { return localStorage.getItem(key); } catch (_) { return null; }
  }

  function save(key, value) {
    try { localStorage.setItem(key, value); } catch (_) {}
  }

  function visitorId() {
    var existing = stored(VISITOR_KEY);
    if (existing && /^[A-Za-z0-9_-]{16,80}$/.test(existing)) return existing;
    var created = crypto.randomUUID();
    save(VISITOR_KEY, created);
    return created;
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (character) {
      return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[character];
    });
  }

  function render(data) {
    current = data;
    var selected = stored(VOTE_KEY);
    var voted = Boolean(selected);
    var snapshot = JSON.stringify([data.status, data.totalVotes, data.results, selected, submitting]);
    if (snapshot === renderedSnapshot) return;
    renderedSnapshot = snapshot;
    optionsEl.innerHTML = data.results.map(function (item, index) {
      var choice = selected === item.id || selected === item.flavor;
      var percent = Math.max(0, Math.min(Number(item.percent) || 0, 100));
      var color = /^#[0-9A-Fa-f]{6}$/.test(item.color) ? item.color : '#228EE3';
      var name = escapeHtml(item.flavor);
      var tag = choice ? '<span class="ep-tag">Your vote</span>' :
        index === 0 && data.totalVotes ? '<span class="ep-tag" style="background:#001523;">Leading</span>' : '';
      return '<button type="button" class="ep-row' + (choice ? ' is-voted' : '') +
        (index === 0 && data.totalVotes ? ' is-leader' : '') + '"' +
        (voted || data.status !== 'open' || submitting ? ' disabled' : '') +
        ' data-option-id="' + escapeHtml(item.id) + '" style="--ep-accent:' + color + ';"' +
        ' aria-label="Vote for ' + name + '">' +
        '<div class="ep-line"><span class="ep-name"><span class="ep-dot"></span>' + name + tag +
        '</span><span class="ep-nums"><span class="ep-votes">' + Number(item.votes) +
        (Number(item.votes) === 1 ? ' vote' : ' votes') + '</span><span class="ep-pct">' +
        percent.toFixed(1) + '%</span></span></div>' +
        '<div class="ep-bar"><div class="ep-bar-fill" style="display:block;height:100%;width:' +
        percent.toFixed(1) + '%;background-color:' + color + ';"></div></div></button>';
    }).join('');
    totalEl.textContent = data.totalVotes + ' total votes';
    if (voted) statusEl.textContent = 'Your vote has already been recorded. Thanks for helping choose.';
    else if (data.status !== 'open') statusEl.textContent = 'Voting is currently closed.';
    else if (!submitting) statusEl.textContent = 'Please vote once.';
  }

  async function refresh() {
    var serial = ++refreshSerial;
    var response = await fetch(RESULTS_URL, {headers: {Accept: 'application/json'}, cache: 'no-store'});
    if (!response.ok) throw new Error('Results unavailable.');
    var data = await response.json();
    if (!data.ok || !Array.isArray(data.results)) throw new Error('Results unavailable.');
    if (serial > lastRenderedSerial) {
      lastRenderedSerial = serial;
      lastRefresh = Date.now();
      render(data);
    }
  }

  async function cast(optionId) {
    if (submitting || !current || current.status !== 'open' || stored(VOTE_KEY)) return;
    submitting = true;
    optionsEl.querySelectorAll('button').forEach(function (button) { button.disabled = true; });
    statusEl.textContent = 'Counting your vote...';
    var finalMessage = '';
    try {
      var response = await fetch(VOTE_URL, {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({optionId: optionId, visitorId: visitorId()}),
      });
      var data = await response.json();
      if (!response.ok || !data.ok) throw new Error(data.error || 'Vote was not confirmed.');
      save(VOTE_KEY, data.optionId || optionId);
      finalMessage = data.counted ? 'Thanks. Your vote was counted.' : 'Your vote was already recorded.';
      try { await refresh(); } catch (_) {}
    } catch (error) {
      finalMessage = error.message || 'Could not confirm your vote. Please try again.';
    } finally {
      submitting = false;
      if (current) render(current);
      statusEl.textContent = finalMessage;
    }
  }

  optionsEl.addEventListener('click', function (event) {
    var row = event.target.closest && event.target.closest('.ep-row');
    if (row && !row.disabled) cast(row.getAttribute('data-option-id'));
  });

  optionsEl.innerHTML = '';
  totalEl.textContent = '';
  statusEl.textContent = 'Loading current results...';
  refresh().catch(function () {
    statusEl.textContent = 'Results are unavailable. Please try again later.';
  });

  // Keep open tabs current without making requests while the shopper is away.
  setInterval(function () {
    if (document.visibilityState === 'visible' && !submitting) refresh().catch(function () {});
  }, 30000);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible' && !submitting && Date.now() - lastRefresh > 10000) {
      refresh().catch(function () {});
    }
  });
  window.addEventListener('storage', function (event) {
    if (event.key === VOTE_KEY && current) {
      render(current);
      refresh().catch(function () {});
    }
  });
})();
